import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Loading from "../../components/Main/Loading";
import ToastError from "../../components/Notification/ToastError";
import Tracer from "../../components/Track/Tracer";
import TrackPage from "../../components/Track/Track";
import { deconverts, headers } from "../../libs";

const initialApi = { id: 0, invoice: "", no_hp: "" };

function Track() {
  const { search } = useLocation();
  const history = useHistory();

  const [isModal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadData, setLoadData] = useState(false);
  const [data, setData] = useState(null);
  const [lastTrack, setLastTrack] = useState("");
  const [dataApi, setDataApi] = useState(initialApi);
  const [dataTracking, setDataTracking] = useState([]);

  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState("");
  const onError = () => {
    setOpen(false);
  };

  const GetParam = async (url) => {
    const data = await deconverts(url.token.toString().replace(/ /g, "+"));

    if (data) {
      setDataApi(data);
      await GetDataTrack(data);
    } else {
      history.push("/");
    }
  };

  const GetData = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/tracking/detail`,
        { id: dataApi.id },
        {
          headers: await headers({
            id: dataApi.id,
          }),
        }
      );

      if (Number(response.data.code) === 200 && response.data.data.length > 0) {
        setDataTracking(response.data.data);
        setLoading(false);
      } else {
        setOpen(true);
        setResponse("");

        setLoading(false);
      }
    } catch (e) {
      setOpen(true);
      setResponse("");

      setLoading(false);
    }
  };

  const GetDataTrack = async (data) => {
    setLoadData(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/tracking`,
        { invoice: data.invoice, no_hp: data.no_hp.toString() },
        {
          headers: await headers({
            invoice: data.invoice,
            no_hp: data.no_hp.toString(),
          }),
        }
      );

      const lastT = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/tracking/detail`,
        { id: data.id },
        {
          headers: await headers({
            id: data.id,
          }),
        }
      );

      if (Number(response.data.code) === 200 && response.data.data) {
        setData(response.data.data);
        if (lastT.data.data.length > 0) {
          setLastTrack(lastT.data.data[lastT.data.data.length - 1].keterangan);
        } else {
          setLastTrack("Belum terdapat tracking pemeriksaan");
        }
        setLoadData(false);
      } else {
        setOpen(true);
        setResponse("Mohon maaf, untuk data tersebut tidak di temukan");

        setLoadData(false);
      }
    } catch (e) {
      setOpen(true);
      setResponse("");

      setLoadData(false);
    }
  };

  useEffect(() => {
    if (search) {
      const urlParams = Object.fromEntries([...new URLSearchParams(search)]);
      GetParam(urlParams);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const onModal = async () => {
    setModal(true);
    await GetData();
  };

  const onCancel = () => {
    setModal(false);
    onReset();
  };

  const onReset = () => {
    setDataTracking([]);
    setLoading(false);
  };

  return (
    <>
      <Tracer props={{ isModal, loading, onCancel, dataTracking }} />
      <ToastError props={{ open, response, onError }} />

      {loadData ? (
        <Loading />
      ) : (
        <TrackPage props={{ onModal, data, lastTrack }} />
      )}
    </>
  );
}

export default Track;
